import { createContext, useContext } from 'react'

type SharedViewValue = { isShared: true; token: string } | { isShared: false; token: null }

const SharedViewContext = createContext<SharedViewValue>({ isShared: false, token: null })

export const SharedViewProvider = ({
  token,
  children,
}: {
  token: string
  children: React.ReactNode
}) => (
  <SharedViewContext.Provider value={{ isShared: true, token }}>
    {children}
  </SharedViewContext.Provider>
)

// eslint-disable-next-line react-refresh/only-export-components
export const useSharedView = () => useContext(SharedViewContext)
